module.exports = __webpack_public_path__ + "static/media/referFriendLogin.5e537c1e.png";